const axios = require('axios')

export default class Settings {
    /**
     * Querys for proyects
     */
    postProject(data){
        return axios.post('/settings/projects', data)
    }
    
    patchProject(id, data){
        return axios.patch(`/settings/projects/${id}`, data)
    }

    deleteProject(id){
        return axios.delete(`/settings/projects/${id}`)
    }

    getProject(id) {
        return axios.get(`/settings/projects/${id}`)
    }

    changeStage(id, data) {
        return axios.post(`/settings/projects/${id}/stage`, data)
    }

    postAmmount(id, data) {
        return axios.post(`/settings/projects/${id}/ammount`, data)
    }
    
    deleteAmmount(projectId, id) {
        return axios.delete(`/settings/projects/${projectId}/ammount/${id}`)
    }

    /**
     * Querys for users
     */
    postUser(data){
        return axios.post('/settings/users', data)
    }
    
    patchUser(id, data){
        return axios.patch(`/settings/users/${id}`, data)
    }

    deleteUser(id){
        return axios.delete(`/settings/users/${id}`)
    }

    getUser(id) {
        return axios.get(`/settings/users/${id}`)
    }

    /**
     * Query for roles
     * 
     */
    getResourcesByRole(id) {
        return axios.get(`/settings/roles/${id}/resources`)
    }

    assignPermissions(id, data) {
        return axios.post(`/settings/roles/${id}/resources`, data)
    }

    postRole(data){
        return axios.post('/settings/roles', data)
    }
    
    patchRole(id, data){
        return axios.patch(`/settings/roles/${id}`, data)
    }

    getRole(id) {
        return axios.get(`/settings/roles/${id}`)
    }

    /**
     * Alerts
     */
    updateAlert(id, data){
        return axios.patch(`/alerts/${id}`, data)
    }

    archiveAlert(ids) {
        return axios.delete(`/alerts/archive/${ids}`)
    }


    /**
     * Settings
     */
    getSetting(id) {
        return axios.get(`/settings/configs/${id}`)
    }

    postSetting(data){
        return axios.post('/settings/configs', data)
    }
    
    patchSetting(id, data){
        return axios.patch(`/settings/configs/${id}`, data)
    }


    /**
     * General
     */
    getData(resource, size = 10, page = 1, sort = null, filters = null){
        if(resource){
            switch(resource){
                case "projects":
                    return axios.get(`/settings/projects?page=${page}&size=${size}&${sort}&${filters}`)
                case "users":
                    return axios.get(`/settings/users?page=${page}&size=${size}&${sort}&${filters}`)
                case "roles":
                    return axios.get(`/settings/roles?page=${page}&size=${size}&${sort}&${filters}`)
                case "permissions":
                    return axios.get(`/settings/resources?page=${page}&size=${size}&${sort}&${filters}`)
                case "stages":
                    return axios.get(`/settings/stages?page=${page}&size=${size}&${sort}&${filters}`)
                case "alerts":
                    return axios.get(`/alerts?page=${page}&size=${size}&${sort}&${filters}`)
                case "configurations":
                        return axios.get(`/settings/configs?page=${page}&size=${size}&${sort}&${filters}`)
            }    
        }
    }

    deleteRow(resource, ids){
        if(resource){
            switch(resource){
                case "projects":
                    return axios.delete(`/settings/projects/${ids}`)
                case "users":
                    return axios.delete(`/settings/users/${ids}`)
                case "roles":
                    return axios.delete(`/settings/roles/${ids}`)
                case "configurations":
                    return axios.delete(`/configs/${ids}`)
            }    
        }
    }
}